import { render } from "./ChatView.vue?vue&type=template&id=76b9574f&scoped=true&ts=true"
import script from "./ChatView.vue?vue&type=script&lang=ts"
export * from "./ChatView.vue?vue&type=script&lang=ts"

import "./ChatView.vue?vue&type=style&index=0&id=76b9574f&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76b9574f"]])

export default __exports__